export const environment = {
  production: false,
  development: true,
  apiBaseUrl: 'https://dev.api.rebelpaint.ai/api',
  sentryDsn: '',
};